// D170.5 (USC-BUG-0081): "Spread charges into prices" builds the quotation's
// charges into the line selling prices by line value, on the SERVER (`utils/chargeSpread`, one owner;
// the client's own absorption arithmetic is retired). This file holds only what the page says:
// why the buttons are greyed out, and the words for each refusal code.
import { isFrozenStatus } from '../../utils/quotationFrozen';

/** Why spread and Undo cannot run on this quotation (the server refuses the same), or null. */
export const spreadLockedReason = (status: string | null | undefined, hasConfirmedOrder: boolean): string | null =>
  isFrozenStatus(status)
    ? 'This quotation is finalized, sent or rejected: its charges can no longer be spread into its prices, or a spread undone.'
    : hasConfirmedOrder
      ? 'This quotation has a confirmed order: its charges can no longer be spread into its prices, or a spread undone.'
      : null;

const REFUSALS: Record<string, string> = {
  QUOTATION_FROZEN:
    'This quotation is finalized, sent or rejected: its charges can no longer be spread into its prices, or a spread undone. Nothing was changed.',
  QUOTATION_ORDERED:
    'This quotation has a confirmed order: its charges can no longer be spread into its prices, or a spread undone. Nothing was changed.',
  QUOTATION_SPREAD_NOTHING: 'There is nothing to spread: no charges, or less than a cent a unit on every line. Nothing was changed.',
  QUOTATION_SPREAD_NO_LINES:
    'No line can take a share: every line is unpriced, free of charge or locked at its IFS price, or the discount is 100%. Nothing was changed.',
  QUOTATION_SPREAD_UNDO_STALE: 'Undo is no longer available: the quotation changed after the charges were spread. Nothing was changed.',
  QUOTATION_NOT_FOUND: 'This quotation could not be found.',
};

/** The words for a refused spread or Undo, from the server's code (never its sentence). */
export const spreadRefusalMessage = (code: string | undefined, fallback: string): string =>
  (code && REFUSALS[code]) || fallback;
